import React from "react";

import { Card, Divider, Stack, Typography } from '@material-ui/core';
import { WalletTransaction } from "../../../types";
import { ListChildComponentProps } from "react-window";
import timeAgo from "../../../utils/timeAgo";
import { Box } from "@material-ui/system";
import ValueWithLabel from "../../../components/ValueWithLabel";



const UserTransactionItem: React.FC<ListChildComponentProps<WalletTransaction[]>> = ({ data, index, style }) => {
  const transaction = data[ index ];

  return (
    <Box sx={{ mb: 1 }} style={style}>
      <Card variant="outlined" sx={{ p: 2 }}>
        <Stack direction="column" spacing={2}>
          <Stack direction="row" spacing={3}>
            <ValueWithLabel label="Type" value={transaction.type} />
            <ValueWithLabel label="Name" value={transaction.name} />
          </Stack>
          <Stack direction="row" spacing={3}>
            <ValueWithLabel label="Created" value={timeAgo(transaction.createTime.toDate())} />
            <ValueWithLabel label="Coins" value={transaction.coins} />
          </Stack>
          <Divider />
          <Box sx={{ overflow: 'scroll', p: 1 }} >
            <Typography>
              {JSON.stringify(transaction.data)}
            </Typography>
          </Box>
        </Stack>


      </Card>
    </Box>
  );
};

export default UserTransactionItem;